import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight, Building2, MessageCircle, Phone, Ruler, ScanSearch, Search, TrendingUp } from "lucide-react";
import { Reveal, SectionHeading } from "../components/Reveal";
import { GOALS } from "../lib/protocols";
import { PHONE_OFFICE, WHATSAPP_URL } from "../lib/api";
import { useLeadModal } from "../components/ConversionContactModal";

const ICONS = {
  "building-2": Building2,
  search: Search,
  "trending-up": TrendingUp,
  ruler: Ruler,
  "scan-search": ScanSearch,
};

function GoalRow({ goal, open, onToggle }) {
  const openLead = useLeadModal();
  const Icon = ICONS[goal.icon] || Building2;
  const waHref = `https://wa.me/393514129152?text=${encodeURIComponent(goal.whatsapp)}`;

  return (
    <div className={`goal-row ${open ? "active" : ""}`} data-testid={`goal-${goal.id}`}>
      <button
        className="goal-row-inner text-left"
        onClick={onToggle}
        aria-expanded={open}
        data-testid={`goal-toggle-${goal.id}`}
      >
        <span className="goal-icon grid h-10 w-10 place-items-center border border-[#c9a45c]/35 text-gold">
          <Icon size={17} strokeWidth={1.6} />
        </span>
        <span className="goal-title font-serif text-[21px] leading-tight sm:text-[30px] sm:leading-none">{goal.title}</span>
        <span className="goal-copy text-[13px] leading-relaxed sm:text-[14px] text-[#929292]">{goal.copy}</span>
        <span className={`goal-arrow grid place-items-center text-gold transition-transform duration-300 ${open ? "rotate-90" : ""}`}>
          <ArrowUpRight size={20} />
        </span>
      </button>
      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="overflow-hidden"
          >
            <div className="flex flex-wrap gap-2.5 pb-6 pl-0 sm:pl-[82px]">
              <a href={PHONE_OFFICE} data-testid={`goal-call-${goal.id}`} className="btn btn-outline !min-h-[38px] !px-4 !text-[9px]">
                <Phone size={12} /> Chiama l'ufficio
              </a>
              <a
                href={waHref}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`goal-whatsapp-${goal.id}`}
                className="btn !min-h-[38px] !px-4 !text-[9px] border !border-[#9bd58e]/50 bg-[#9bd58e]/8 !text-[#9bd58e]"
              >
                <MessageCircle size={12} /> Scrivi su WhatsApp
              </a>
              <button
                data-testid={`goal-lead-${goal.id}`}
                onClick={() => openLead(goal.id)}
                className="btn btn-gold !min-h-[38px] !px-4 !text-[9px]"
              >
                Richiedi ora
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default function ObiettiviSection() {
  const [openGoal, setOpenGoal] = useState("vendere");

  return (
    <section id="obiettivi" className="section" data-testid="obiettivi-section">
      <div className="container-hub">
        <SectionHeading
          eyebrow="I tuoi obiettivi"
          title={<>UN SOLO INTERLOCUTORE. <span className="gold-text">CINQUE DIREZIONI POSSIBILI.</span></>}
          lead="Qualunque sia il tuo obiettivo immobiliare, c'è un protocollo A.C. HUB costruito su misura. Scegli la direzione: della regia pensiamo noi."
        />
        <Reveal delay={0.1} className="mt-14 border-t border-[#c9a45c]/22">
          {GOALS.map((goal) => (
            <GoalRow
              key={goal.id}
              goal={goal}
              open={openGoal === goal.id}
              onToggle={() => setOpenGoal(openGoal === goal.id ? null : goal.id)}
            />
          ))}
        </Reveal>
      </div>
    </section>
  );
}
